import React, { useContext, useEffect, useState } from 'react';
import { ListGroup, Row, Col, Image, Modal, Button, Container, Card, Table } from 'react-bootstrap';
import './product_styles.css'
import { OrderContext } from '../../context/OrderContext';
import { useNavigate } from 'react-router-dom';





const SummaryProduct = () => {


  const { refundProduct, setRefundProduct} = useContext(OrderContext);
  const navigate = useNavigate();

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);



  useEffect(() => {
    if (refundProduct) {
      // Tüm claim'lerden product'ları topla
      const allProducts = refundProduct.flatMap(claim => claim.SubjectOrderProducts || []);
      
      // Her product için tüm claim'lerde requested_quantity ara
      const productsWithRequestedQty = allProducts.map((product) => {
        let requestedQty = null;
        // Tüm claim'lerde ara
        for (const claim of refundProduct) {
          if (claim.items && Array.isArray(claim.items)) {
            const item = claim.items.find(i => i.order_product?.Id === product.Id);
            if (item && item.requested_quantity) {
              requestedQty = item.requested_quantity;
              break; // Bulunca dur
            }
          }
        }
        return {
          ...product,
          requested_quantity: requestedQty || product.Count || 0
        };
      });
      
      const processedProducts = productsWithRequestedQty.filter(product => product.processed);
      
      setFilteredProducts(processedProducts);
      
      const totalQuantity = processedProducts.reduce((total, product) => total + product.Count, 0);
      const totalPrice = processedProducts.reduce((total, product) => total + product.BasePrice, 0);
      
      setTotalProducts(totalQuantity);
      setTotalAmount(totalPrice);
    }
  }, [refundProduct]);

  // console.log("filteredProducts", filteredProducts)


  const handleClick = () => {
    // Son sayfaya geçerken history'de yeni bir adım eklemek yerine
    // mevcut adımı replace edelim ki geri tuşu ile bu sayfaya dönülmesin.
    navigate("/return-summary", { replace: true });
  };

  function formatCurrency(amount) {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(amount);
  }


  return (
    <>
  <Container className="d-flex flex-column justify-content-center align-items-center summary-product-container" style={{ minHeight: '100vh' }}>
    
    {/* Ürün Listesi */}
    <Row className="w-100 justify-content-center">
          <Col md={6}>
            <ListGroup>
              {filteredProducts?.map((product) => (
                <ListGroup.Item key={product.Id} className="product-card">
                  <Row className="g-1 align-items-center row_box">
                    <Col xs={4} md={4} l={4} className="product-image-col">
                      <Image src={product.image} alt={product.Name} className="product-image" />
                    </Col>
                    <Col xs={8} md={8} l={8} className="product-info">
                      <h5 className="product-title">{product.Name}</h5>
                      <p className="product-size-color">Adet: {product.Count}</p>
                      {product.requested_quantity && (
                        <p className="product-size-color" style={{ color: '#28a745', fontWeight: '500' }}>
                          Talep Adedi: {product.requested_quantity}
                        </p>
                      )}
                      <p className="product-size-color-price">Fiyat: {formatCurrency(product.BasePrice)}</p>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>

    {/* İade Özeti */}
    <Row className="w-100 justify-content-center">
          <Col md={6} >
            <Card className="mt-2 summary-card w-100">
              <Card.Header className='summary-header'>İade Özeti</Card.Header>
              <Card.Body style={{width:'100%'}}>
                <Row>
                  <Col xs={6} md={6} className="summary-title">
                    Ürün Adedi:
                  </Col>
                  <Col xs={6} md={6} className="summary-value">
                    {totalProducts}
                  </Col>
                </Row>
                <Row>
                  <Col xs={6} md={6} className="summary-title">
                    İade Tutarı:
                  </Col>
                  <Col xs={6} md={6} className="summary-value">
                    {formatCurrency(totalAmount)} 
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>


    <Row className="w-100 justify-content-center">
      <Col  md={6}>
         <Button className='mt-3 w-100 transparent-black-button' onClick={handleClick}> devam et </Button>
      </Col>
    </Row>
  </Container>
</>

  );
};

export default SummaryProduct;
